function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MainTemplate = require('./main.template');
var Main = /*#__PURE__*/function () {
  function Main(app, mod) {
    _classCallCheck(this, Main);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(Main, [{
    key: "hasGetSaito",
    value: function hasGetSaito() {
      try {
        var _this$app$modules$ret;
        return !!((_this$app$modules$ret = this.app.modules.returnModule('Mixin')) !== null && _this$app$modules$ret !== void 0 && _this$app$modules$ret.purchase_overlay);
      } catch (err) {
        return false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var inactive = data.inactive === true || !this.hasGetSaito();
      var root = document.querySelector('.faucet-home');
      if (!root) {
        this.app.browser.addElementToDom(MainTemplate(this.app, this.mod, {
          inactive: inactive
        }));
        this.attachEvents();
        return;
      }
      var btn = root.querySelector('.saito-button-primary');
      var msg = root.querySelector('.inactive-message');
      if (btn) {
        btn.hidden = inactive;
      }
      if (msg) {
        msg.hidden = !inactive;
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var btn = document.querySelector('.faucet-home .saito-button-primary');
      if (!btn) {
        return;
      }
      btn.onclick = function () {
        if (!_this.hasGetSaito()) {
          _this.render({
            inactive: true
          });
          return;
        }
        _this.app.connection.emit('saito-purchase-launch');
      };
    }
  }]);
}();
module.exports = Main;